import { Controller } from "@hotwired/stimulus";
import "./component.scss";

const MAX_CATEGORIES = 3;
// @süle hier musst du nochmal drüberschauen irgendwie werden die Tags nciht richtig wieder abgewählt und man kann es noch nicht mit der tastatur machen.

export default class extends Controller {
  static targets = ["list", "searchInput", "checkbox", "tag"];

  connect() {
    this.allCheckedCheckboxes().forEach((checkbox) => {
      let categoryId = checkbox.value;
      this.toggleTag(categoryId)
    });
  }

  search(event) {
    let query = event.target.value.toLowerCase().trim();

    this.openList();
    this.filterListElements(query);
  }

  filterListElements(query) {
    this.listTarget.querySelectorAll("label").forEach((item) => {
      item.style.display = this.itemInQuery(item, query) ? "block" : "none";
    });
  }

  toggle(event) {
    const categoryId = event.target.value;

    let checkedCount = (this.allCheckedCheckboxes().length);

    if (checkedCount > MAX_CATEGORIES) {
      event.target.checked = false;
    }

    this.toggleTag(categoryId);
  }

  toggleTag(categoryId) {
    const checkbox = this.findCheckbox(categoryId);
    const tag = this.findTag(categoryId);

    if (checkbox.checked) {
      tag.style.display = "block";
    }
    else {
      tag.style.display = "none";
    }
  }

  uncheck(event) {
    const categoryId = event.currentTarget.dataset.value;

    const checkbox = this.findCheckbox(categoryId);
    checkbox.checked = false;
    this.toggleTag(categoryId);
  }

  // Helpers

  findCheckbox(categoryId) {
    return this.checkboxTargets.find(
      (checkbox) => checkbox.value == categoryId
    );
  }

  findTag(categoryId) {
    return this.tagTargets.find(
      (tag) => tag.dataset.value == categoryId
    );
  }

  itemInQuery(item, query) {
    return item.textContent.toLowerCase().includes(query);
  }

  allCheckedCheckboxes() {
    return this.checkboxTargets.filter((checkbox) => checkbox.checked);
  }

  closeList() {
    this.listTarget.hidden = true
  }

  openList() {
    this.listTarget.hidden = false
  }

  clickOutside(event) {
    if (event.target === this.searchInputTarget) {
      this.search(event);
    } else {
      this.closeList();
    }
  }
}
